export default {
    COMMON: {
        SITE: "Establecimiento | Establecimientos",
        SILO: "Silo | Silos",
        SECTION: "Sección | Secciones",
        DESCRIPTION: "Descripción",
        TEMPERATURE: "Temperatura",
        HUMIDITY: "Humedad",
        MOISTURE: "Humedad del grano",
        MOISTABLE: "Humedad",
        CO2: "CO2",
        SAVE: "Guardar",
        CANCEL: "Cancelar",
        LAST_SYNC: "Ultimos datos",
        SAVE_SUCCESS: "Guardado exitoso",
        SAVE_FAILURE: "Ups.. parece que hubo un error",
        NO_DATA: "Sin datos",
        BACK_DASHBOARD: "Volver a Dashboard",
        CLICK_SILO: "Doble click para ver detalles del silo",
        STATUS: "Estado",
        SILO_DETAILS: "Ver detalles",
        CLOSE: "Cerrar"
    },
    GRAIN: {
        SOJA: "Soja",
        MAIZ: "Maiz",
        CEBADA: "Cebada",
        TRIGO: "Trigo",
        GIRASOL: "Girsaol",
        CENTENO: "Centeno",
        POROTO: "Poroto",
        ARROZ: "Arroz"
    },
    SIDEBAR: {
        HISTORICS: "Historicos",
        METRICS: "Métricas",
        CONFIGS: "Configuraciones",
        DAILY_REPORT: "Ultimos Datos",
        DASHBOARD: "Dashboard",
        ANALYTICS: "Analítica",
        RISK_ANALYSIS: "Análisis de riesgo",
        INSURANCE: "Cotiza tu Seguro"
    },
    LOGIN: {
        USERNAME: "Usuario",
        USERNAME_REQUIRED: "Por favor complete el nombre de usuario",
        PASSWORD_REQUIRED: "Por favor complete la contraseña",
        PASSWORD: "Contraseña",
        WELCOME: "¡Bienvenido!",
        SIGN_IN: "Ingresar"
    },
    NAVBAR: {
        PROFILE: "Perfil",
        LOGOUT: "Cerrar sesión",
        ADMIN: "Administrador",
    },
    MONITOR: {
        WARNING_DETAILS: "Detalle de alertas",
        SILO_DATA: "Datos del silo"
    },
    PROFILE: {
        CELSIUS: "Grados Celcius [C°]",
        FAHRENHEITS: "Grados Fahrenheits [F]",
        PPM: "Partes por millon [ppm]",
        PERCENTAGE: "Porcentaje [%]",
        USER_DATA: "Datos del usuario",
        USER_PROFILE: "Datos del usuario",
        UNITS_DEFAULT: "Unidades por defecto",
        NAME: "Nombre",
        LAST_NAME: "Apellido",
        CONTACT_PHONE: "Teléfono de contacto",
        EMAIL: "Email",
        UNITS: "Unidades",
        CHANGE_PASSWORD: "Cambiar contraseña",
        NEW_PASSWORD: "Cambio de contraseña",
        FILL_NEW_PASSWORD: "Ingrese la nueva contraseña",
        LOGOUT: "Cerrar sesión",
        LOGOUT_MESSAGE: "Para que los cambios tomen efecto es necesario volver a iniciar sesión",
        CONF_CHANGE: "Cambio de configuración",
        SILO_DETAIL_ENABLE: "Detalle de silos activado",
        SILO_DETAIL_DISABLE: "Detalle de silos desactivado",
        CONTINUE: "Continuar",
        SILO_DETAIL: "Detalle de Silo",
        TIMEZONE: "Zona horaria",
        CONFIRM_PASSWORD: "Reingrese su Contraseña",
        FILL_NEW_PASSWORD: "Por favor ingrese una nueva contraseña",
        FILL_CONFIRM_PASSWORD: "Por favor reingrese su contraseña",
        MAX_LENGTH_EXCEEDED: "La contraseña no puede tener más de 44 caracteres",
        PASSWORDS_DO_NOT_MATCH: "Las contraseñas no coinciden",
        PASSWORD_CHANGE_CANCELLED: "Cambio de contraseña cancelado",
        EDIT_MESSAGE: "Por favor para editar su perfil utilice la nueva Web. Cualquier duda comunicarse con Wiagro"
    },
    RISK_ANALYSIS: {
        TITLE: "Análisis de riesgo",
        NO_SECTIONS: "Este silo no tiene sensores asociados",
        LOW: "Bajo",
        MEDIUM: "Medio",
        HIGH: "Alto",
        VERY_HIGH: "Muy alto"
    },
    CONFIGS: {
        CONFIGS: "Configuraciones",
        SUBTITLE: "Seleccione las unidades minimas y maximas para cada umbral"
    },
    ERROR: {
        1: "No se indicó la versión de la interfaz",
        2: "No se especificó un comando",
        3: "Faltan parámetros obligatorios para el comando especificado",
        4: "Comando icorrecto",
        5: "Upps.. ocurrió un error",
        6: "El metodo http es incorrecto para el comando",
        7: "No se contró la version de la interfaz especificada",
        8: "El comando está declarado pero aún no se implmento el servicio",
        9: "Usuario o contraseña inválido",
        10: "Expiró la sesión",
        11: "Parámetro incorrecto en la request",
        12: "Se superó  la cantidad de sesiones concurrentes",
        13: "El establecimiento no pertenece al usuario",
        14: "No existe session para el usuario",
        15: "El establecimiento no tiene ningun silo asociado",
        16: "No se encontró el silo para el establecimiento indicado",
        COMMUNICATION_FAILURE: 'Falla de comunicación',
        OUTDATED: 'Desactualizado'
    },
    REPORTS: {
        DAILY_REPORT: "Reporte diario",
        NO_SECTIONS: "Este silo no tiene sensores asociados",
        NO_DATA: "S/D",
        NO_DATA_FOR_DATE_AND_SILO: "No hay mediciones para {silo} y la fecha seleccionada",
        PICK_A_DATE: "Seleccione una fecha",
        LAST_DATA: "Ultimos Datos",
        STATUS_COLOR: "Color de estado",
        BAGGED_DATE:"Fecha de embolsado: ",
        INI_MOISTURE: "Humedad inicial: ",
        TONS: "Toneladas: ",
        SILO_DATA: "Datos del silo",
        SILO_DETAILS: "Detalles del silo",
        SENSOR_FAIL: "Falla de Sensor",
    },
    HISTORICS: {
        HISTORICS: "Históricos",
        DATE_FROM: "Desde",
        DATE_TO: "Hasta",
        NO_SITES: "Todavia no tienes ningún establecimiento creado",
        SILO_WITH_NO_SENSORS: "Este silo no tiene sensores",
        PICK_A_DATE: "Seleccione una fecha",
        NO_DATA_FOR_THIS_DATE: "Sin datos para la fecha seleccionada",
        SECTION_NAME: "Sección {section}",

    },
    STATUS: {
        NO_DATA: "Sin Datos",
        OK: "Ok",
        WARN: "Medición fuera del rango establecido",
        ERROR: "Medición en rangos críticos",
        DISABLED: "Deshabilitada"

    },
    INDICATOR: {
        OK: "Ok",
        DANGER: "Peligro",
        WARN: "Alerta",
        NO_DATA: "Sin datos",
    },
    EVENTS: {
        MOV: "Alerta de movimiento",
        STAT_TEMP: "Estado Actual de temperatura: {status}",
        STAT_CO2: "Estado Actual de CO2: {status}",
        STAT_HUM: "Estado Actual de humedad: {status}",
        STAT_HUM_GRANO: "Estado Actual de humedad de grano: {status}",
        NO_EVENTS: "No hay alertas",
        BREAK_BAG: "Posible rotura de bolsa",
        AVERY_BAG: "Posible apertura de bolsa",
        HUM_ALERT: "Alerta de humedad"        

    },
    el: {
        select: {
            noData: "Sin datos",
            placeholder: "Seleccione una opción"
        },
        table: {
            confirmFilter: "Confirmar",
            resetFilter: "Borrar"
        },
        datepicker: {
            now: "Ahora",
            today: "Hoy",
            cancel: "Cancelar",
            clear: "Despejar",
            confirm: "Confirmar",
            selectDate: "Seleccionar fecha",
            selectTime: "Seleccionar hora",
            startDate: "Fecha Incial",
            startTime: "Hora Inicial",
            endDate: "Fecha Final",
            endTime: "Hora Final",
            prevYear: "Año Anterior",
            nextYear: "Próximo Año",
            prevMonth: "Mes Anterior",
            nextMonth: "Próximo Mes",
            year: "",
            month1: "Enero",
            month2: "Febrero",
            month3: "Marzo",
            month4: "Abril",
            month5: "Mayo",
            month6: "Junio",
            month7: "Julio",
            month8: "Agosto",
            month9: "Septiembre",
            month10: "Octubre",
            month11: "Noviembre",
            month12: "Diciembre",
            month: 'Mes',
            week: 'semana',
            weeks: {
                sun: 'D',
                mon: 'L',
                tue: 'M',
                wed: 'M',
                thu: 'J',
                fri: 'V',
                sat: 'S'
            },
            months: {
                jan: 'Ene',
                feb: 'Feb',
                mar: 'Mar',
                apr: 'Abr',
                may: 'Mayo',
                jun: 'Jun',
                jul: 'Jul',
                aug: 'Ago',
                sep: 'Set',
                oct: 'Oct',
                nov: 'Nov',
                dec: 'Dic'
            }
        }
    }
};